import { FC } from 'react';
import { FormProvider } from 'react-hook-form';

import { ERuntimeSettings } from '../../../common/types/runtimeSettings';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { Content } from '../../components/Content';
import { FormLayout } from '../../components/FormLayout';
import { TitleForm } from '../../components/TitleForm';
import { useCalculatorForm } from '../../hooks';
import { TElement } from '../../types/calculator';

interface IFormInnerProps {
  handleSetFormRef: (node: HTMLFormElement | null) => void;
  formRef: HTMLFormElement | null;
  formScheme: TElement[];
}

export const FormInner: FC<IFormInnerProps> = ({ formScheme, formRef, handleSetFormRef }: IFormInnerProps) => {
  const { config } = useApplicationContext();
  const { reactHookForm } = useCalculatorForm(formScheme, formRef);
  const isMortgageLandingRedesignEnabled =
    config.get<boolean>(ERuntimeSettings.mortgageLandingRedesignEnabled) ?? false;

  return (
    <FormProvider {...reactHookForm}>
      <FormLayout>
        <form ref={handleSetFormRef}>
          {!isMortgageLandingRedesignEnabled ? <TitleForm>Ипотечный калькулятор</TitleForm> : null}
          <Content elements={formScheme} data-testid="form-content" />
        </form>
      </FormLayout>
    </FormProvider>
  );
};

FormInner.displayName = 'FormInner';
